import { AppRouteConfig, breadcrumbs } from '..';
import { eventManageApplicationsRoutes } from './event-application';

export enum EventsRouteName {
	events = 'events',
	editEventMain = 'EditEventMain',
	draftEventList = 'DraftEventList',
	currentEventList = 'CurrentEventList',
	allEventList = 'AllEventList',
	newEvent = 'NewEvent',
	editEvent = 'EditEvent',
	eventAttendanceList = 'EventAttendanceList',
	eventScheduleList = 'EventScheduleList',
	eventScheduleAttendanceList = 'EventScheduleAttendanceList',
	eventTicketList = 'EventTicketList',
	eventScheduleAttendanceListContactSearch = 'EventScheduleAttendanceListContactSearch',
	eventScheduleAttendanceListScanProfile = 'EventScheduleAttendanceListScanProfile',
	eventScheduleAttendanceListNewApplication = 'EventScheduleAttendanceListNewApplication',
	eventAttendanceImportList = 'EventAttendanceImportList',
	eventAttendanceImportContactDetails = 'EventAttendanceImportContactDetails',
	eventAttendanceImportContactSearchList = 'EventAttendanceImportContactSearchList',
	eventAttendanceImportContactSelectList = 'EventAttendanceImportContactSelectList',
	eventApplicationList = 'EventApplicationList',
	eventApplicationListContactSearchList = 'EventApplicationListContactSearchList',
	eventApplicationListScanProfile = 'EventApplicationListScanProfile',
	eventApplicationNewApplication = 'EventApplicationNewApplication',
	eventApplicationNewContactApplication = 'EventApplicationNewContactApplication',
	eventAttendanceQrCodeScanner = 'EventAttendanceQrCodeScanner',
	eventTicketQrCodeScanner = 'EventTicketQrCodeScanner',
}

export function eventsRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'draft',
			name: EventsRouteName.draftEventList,
			component: () => import('../../views/event/DraftList.vue'),
			props: { eventListType: 'draft' },
			meta: {
				breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('eventDraft')],
				caslSubject: 'events.current_draft_all_events',
				caslAction: 'view',
				maskFeature: ['events'],
			},
		},

		{
			path: 'current',
			component: { render: c => c('router-view') },
			props: { eventListType: 'current' },
			meta: {
				caslSubject: 'events.current_draft_all_events',
				caslAction: 'view',
			},
			children: [
				{
					path: '',
					name: EventsRouteName.currentEventList,
					component: () => import('../../views/event/CurrentList.vue'),
					props: { eventListType: 'current' },
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('eventCurrent'),
						],
						maskFeature: ['events'],
					},
				},
				...eventManageApplicationsRoutes(
					EventsRouteName.currentEventList,
					breadcrumbs.get('eventCurrent'),
				),
			],
		},
		{
			path: 'all',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: EventsRouteName.allEventList,
					component: () => import('../../views/event/AllList.vue'),
					props: { eventListType: 'all' },
					meta: {
						breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('eventAll')],
						caslSubject: 'events.current_draft_all_events',
						caslAction: 'view',
						maskFeature: ['events'],
					},
				},
				// all event should have its own routes instead of using current
				...eventManageApplicationsRoutes(
					EventsRouteName.allEventList,
					breadcrumbs.get('eventAll'),
				),
			],
		},
		{
			path: 'attendance',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: EventsRouteName.eventAttendanceList,
					component: () =>
						import('../../views/event/attendance/AttendanceEventList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('eventAttendance'),
						],
						caslSubject: 'events.attendance',
						caslAction: 'view',
						maskFeature: ['events'],
					},
				},
				{
					path: 'ticketing/:eventId',
					component: { render: c => c('router-view') },
					meta: {
						caslSubject: 'events.attendance',
						caslAction: 'view',
					},
					children: [
						{
							path: '',
							name: EventsRouteName.eventTicketList,
							component: () =>
								import('../../views/event/ticketing/TicketRedeemList.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('eventAttendance'),
									breadcrumbs.get('eventTicketingRedeem'),
								],
							},
						},
						{
							path: ':optionId/redeem',
							name: EventsRouteName.eventTicketQrCodeScanner,
							component: () =>
								import('../../views/event/ticketing/QrCodeScanner.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('eventAttendance'),
									breadcrumbs.get('eventTicketingRedeem'),
									breadcrumbs.get('eventTicketingQrCodeScanner'),
								],
							},
						},
					],
				},
				{
					path: ':eventId',
					component: { render: c => c('router-view') },
					children: [
						{
							path: '',
							name: EventsRouteName.eventScheduleList,
							component: () =>
								import('../../views/event/attendance/ScheduleInstanceList.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('eventAttendance'),
									breadcrumbs.get('eventAttendanceAllTimeslots'),
								],
								caslSubject: 'events.attendance',
								caslAction: 'view',
							},
						},
						{
							path: 'import',
							component: () =>
								import(
									'../../views/event/attendance/import/EventAttendanceImportContainer.vue'
								),
							props: {
								internal: true,
							},
							meta: {
								caslSubject: 'events.manage_applications',
								caslAction: 'edit',
							},
							children: [
								{
									path: '',
									name: EventsRouteName.eventAttendanceImportList,
									component: () =>
										import(
											'../../views/event/attendance/import/InternalEventAttendanceImportList.vue'
										),
									meta: {
										breadcrumbs: [
											breadcrumbs.get('home'),
											breadcrumbs.get('eventAttendance'),
											breadcrumbs.get('eventAttendanceAllTimeslots'),
											breadcrumbs.get('eventAttendanceImport'),
										],
									},
								},
								{
									path: 'contact/:id',
									name: EventsRouteName.eventAttendanceImportContactDetails,
									component: () =>
										import('../../views/contact/ContactDetails.vue'),
									meta: {
										breadcrumbs: [
											breadcrumbs.get('home'),
											breadcrumbs.get('eventAttendance'),
											breadcrumbs.get('eventAttendanceAllTimeslots'),
											breadcrumbs.get('eventAttendanceImport'),
											breadcrumbs.get('contactDetail'),
										],
									},
								},
								{
									path: 'search-contact',
									name: EventsRouteName.eventAttendanceImportContactSearchList,
									component: () =>
										import(
											'../../views/event/attendance/import/EventAttendanceImportContactSearchList.vue'
										),
									meta: {
										breadcrumbs: [
											breadcrumbs.get('home'),
											breadcrumbs.get('eventAttendance'),
											breadcrumbs.get('eventAttendanceAllTimeslots'),
											breadcrumbs.get('eventAttendanceImport'),
											breadcrumbs.get('eventAttendanceImportContactSearch'),
										],
									},
								},
								{
									path: ':index/select',
									name: EventsRouteName.eventAttendanceImportContactSelectList,
									component: () =>
										import(
											'../../views/event/attendance/import/EventAttendanceImportContactSelectList.vue'
										),
									meta: {
										breadcrumbs: [
											breadcrumbs.get('home'),
											breadcrumbs.get('eventAttendance'),
											breadcrumbs.get('eventAttendanceAllTimeslots'),
											breadcrumbs.get('eventAttendanceImport'),
											breadcrumbs.get('eventAttendanceImportContactSearch'),
										],
									},
								},
							],
						},

						{
							path: ':scheduleId/:scheduleInstanceId',
							component: { render: c => c('router-view') },
							children: [
								{
									path: '',
									name: EventsRouteName.eventScheduleAttendanceList,
									component: () =>
										import('../../views/event/attendance/AttendanceList.vue'),
									meta: {
										breadcrumbs: [
											breadcrumbs.get('home'),
											breadcrumbs.get('eventAttendance'),
											breadcrumbs.get('eventAttendanceAllTimeslots'),
											breadcrumbs.get('eventAttendanceAttendanceList'),
										],
										caslSubject: 'events.attendance',
										caslAction: 'view',
									},
								},
								{
									path: 'scan-profile',
									component: { render: c => c('router-view') },
									children: [
										{
											path: '',
											name:
												EventsRouteName.eventScheduleAttendanceListScanProfile,
											component: () =>
												import('../../views/event/attendance/ScanProfile.vue'),
											meta: {
												breadcrumbs: [
													breadcrumbs.get('home'),
													breadcrumbs.get('eventAttendance'),
													breadcrumbs.get('eventAttendanceAllTimeslots'),
													breadcrumbs.get('eventAttendanceAttendanceList'),
													breadcrumbs.get('eventAttendanceScanProfile'),
												],
												caslSubject: 'events.attendance',
												caslAction: 'view',
											},
										},
										{
											//duplicated set to mimic page transition
											path: 'new',
											name:
												EventsRouteName.eventScheduleAttendanceListScanProfile,
											component: () =>
												import('../../views/event/attendance/ScanProfile.vue'),
											meta: {
												breadcrumbs: [
													breadcrumbs.get('home'),
													breadcrumbs.get('eventAttendance'),
													breadcrumbs.get('eventAttendanceAllTimeslots'),
													breadcrumbs.get('eventAttendanceAttendanceList'),
													breadcrumbs.get('addEventApplication'),
												],
												caslSubject: 'events.attendance',
												caslAction: 'view',
											},
										},
									],
								},
								{
									path: 'check-in',
									name: EventsRouteName.eventAttendanceQrCodeScanner,
									component: () =>
										import('../../views/event/attendance/QrCodeScanner.vue'),
									meta: {
										breadcrumbs: [
											breadcrumbs.get('home'),
											breadcrumbs.get('eventAttendance'),
											breadcrumbs.get('eventAttendanceAllTimeslots'),
											breadcrumbs.get('eventAttendanceAttendanceList'),
											breadcrumbs.get('eventAttendanceQrCodeScanner'),
										],
										caslSubject: 'events.attendance',
										caslAction: 'view',
									},
								},
								{
									path: 'applications/new',
									name:
										EventsRouteName.eventScheduleAttendanceListNewApplication,
									component: () =>
										import(
											'../../views/event/attendance/NewEventApplication.vue'
										),
									meta: {
										breadcrumbs: [
											breadcrumbs.get('home'),
											breadcrumbs.get('eventAttendance'),
											breadcrumbs.get('eventAttendanceAllTimeslots'),
											breadcrumbs.get('eventAttendanceAttendanceList'),
											breadcrumbs.get('addEventApplication'),
										],
										caslSubject: 'events.manage_applications',
										caslAction: 'edit',
									},
								},
								{
									path: 'search-contact',
									name:
										EventsRouteName.eventScheduleAttendanceListContactSearch,
									component: () =>
										import(
											'../../views/event/attendance/NewEventApplicationContactSearch.vue'
										),
									meta: {
										breadcrumbs: [
											breadcrumbs.get('home'),
											breadcrumbs.get('eventAttendance'),
											breadcrumbs.get('eventAttendanceAllTimeslots'),
											breadcrumbs.get('eventAttendanceAttendanceList'),
											breadcrumbs.get('addEventApplicationContactSearch'),
										],
										caslSubject: 'events.manage_applications',
										caslAction: 'edit',
									},
								},
								{
									path: 'import',
									component: () =>
										import(
											'../../views/event/attendance/import/EventAttendanceImportContainer.vue'
										),
									meta: {
										caslSubject: 'events.manage_applications',
										caslAction: 'edit',
									},
									children: [
										{
											path: '',
											name: EventsRouteName.eventAttendanceImportList,
											component: () =>
												import(
													'../../views/event/attendance/import/GeneralEventAttendanceImportList.vue'
												),
											meta: {
												breadcrumbs: [
													breadcrumbs.get('home'),
													breadcrumbs.get('eventAttendance'),
													breadcrumbs.get('eventAttendanceAllTimeslots'),
													breadcrumbs.get('eventAttendanceAttendanceList'),
													breadcrumbs.get('eventAttendanceImport'),
												],
											},
										},
										{
											path: 'contact/:id',
											name: EventsRouteName.eventAttendanceImportContactDetails,
											component: () =>
												import('../../views/contact/ContactDetails.vue'),
											meta: {
												breadcrumbs: [
													breadcrumbs.get('home'),
													breadcrumbs.get('eventAttendance'),
													breadcrumbs.get('eventAttendanceAllTimeslots'),
													breadcrumbs.get('eventAttendanceAttendanceList'),
													breadcrumbs.get('eventAttendanceImport'),
													breadcrumbs.get('contactDetail'),
												],
											},
										},
										{
											path: 'search-contact',
											name:
												EventsRouteName.eventAttendanceImportContactSearchList,
											component: () =>
												import(
													'../../views/event/attendance/import/EventAttendanceImportContactSearchList.vue'
												),
											meta: {
												breadcrumbs: [
													breadcrumbs.get('home'),
													breadcrumbs.get('eventAttendance'),
													breadcrumbs.get('eventAttendanceAllTimeslots'),
													breadcrumbs.get('eventAttendanceAttendanceList'),
													breadcrumbs.get('eventAttendanceImport'),
													breadcrumbs.get('eventAttendanceImportContactSearch'),
												],
											},
										},
										{
											path: ':index/select',
											name:
												EventsRouteName.eventAttendanceImportContactSelectList,
											component: () =>
												import(
													'../../views/event/attendance/import/EventAttendanceImportContactSelectList.vue'
												),
											meta: {
												breadcrumbs: [
													breadcrumbs.get('home'),
													breadcrumbs.get('eventAttendance'),
													breadcrumbs.get('eventAttendanceAllTimeslots'),
													breadcrumbs.get('eventAttendanceAttendanceList'),
													breadcrumbs.get('eventAttendanceImport'),
													breadcrumbs.get('eventAttendanceImportContactSearch'),
												],
											},
										},
									],
								},
							],
						},
					],
				},
			],
		},
	];
}

export function eventsEditRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'new',
			name: EventsRouteName.newEvent,
			component: () => import('../../views/event/EventEdit.vue'),
		},
		{
			path: ':id',
			name: EventsRouteName.editEvent,
			component: () => import('../../views/event/EventEdit.vue'),
		},
	];
}
